import commonGetter from '../getters/commonGetter'
import commonAction from '../actions/commonAction'
import commonMutation from '../mutations/commonMutation'

const commonModule = {
    state: {
        depts: [],
        zdDepts: [],
        transferDepts: [],
        caseReasons: [],
        docUseTypes: [],

        deptUsers: [],

        docCatalogs: {},
        allDocCatalogs: [],

        docInRecords: {},
        docInCodeSequence: null,

        docOutRecords: {},
        docOutDocCatalogs: [],

        docReceiveRecords: {},
        docReceiveDocCatalogs: [],

        docs: {},
        docFeedbacks: {},

        docStockStats: [],
        docUseStats: [],

        cases: {},
        myCases: {},
        receiveCases: {},
        caseDetails: {}
    },
    getters: commonGetter,
    actions: commonAction,
    mutations: commonMutation
}

export default commonModule;



// WEBPACK FOOTER //
// ./src/store/sczdzf/modules/commonModule.js